// extracted by mini-css-extract-plugin
export default {"personal_data_title":"ComponentsTitle_personal_data_title__8aqU8","title":"ComponentsTitle_title__KNQ72"};